export function findFirstFocusableElementAfter(element) {
    const focusableSelectors = [
        'a[href]:not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"])',
        'input:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        '[tabindex]:not([tabindex="-1"])',
    ].join(',');
    const allFocusable = Array.from(document.querySelectorAll(focusableSelectors));
    let currentElement = element;
    while (currentElement && !currentElement.matches('header')) {
        currentElement = currentElement.parentElement;
    }
    const navElement = currentElement || element;
    // Find elements that come after the navigation (works with our document structure w/ react widgets wrapped by div)
    const nextFocusableElements = allFocusable.filter((el) => {
        return (!navElement.contains(el) &&
            navElement.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING);
    });
    // Return the first element after the navigation, if any
    return nextFocusableElements.length > 0 ? nextFocusableElements[0] : null;
}
